import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider as ReduxProvider } from 'react-redux'
import { Toaster } from 'react-hot-toast'
import './index.css'
import App from './App.jsx'
import { store } from './store/index.js'
import { toasterOptions } from './toast.js'
// Loaded last so the mobile breakpoint overrides sit at the end of the
// cascade and trump per-page stylesheets without modifying them.
import './mobile.css'

// Belt-and-braces for stale lazy chunks after a deploy. `vite:preloadError`
// fires when Vite's <link rel="modulepreload"> 404s — earlier than the
// lazy() import that lazyWithReload wraps. One-shot via sessionStorage so
// a genuinely-broken new build can't loop-reload. The `load` listener
// clears the flag once the fresh build has fully loaded so the next
// deploy's stale-chunk event can fire again.
const CHUNK_RELOAD_FLAG = 'hiq:chunk-reloaded'
window.addEventListener('vite:preloadError', () => {
  if (sessionStorage.getItem(CHUNK_RELOAD_FLAG)) return
  try {
    sessionStorage.setItem(CHUNK_RELOAD_FLAG, '1')
  } catch {
    /* private mode — proceed without the guard */
  }
  window.location.reload()
})
window.addEventListener('load', () => {
  try {
    sessionStorage.removeItem(CHUNK_RELOAD_FLAG)
  } catch {
    /* ignore */
  }
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ReduxProvider store={store}>
      <BrowserRouter>
        <App />
        <Toaster position="bottom-center" toastOptions={toasterOptions} />
      </BrowserRouter>
    </ReduxProvider>
  </StrictMode>,
)
